export const getMcpRedirectHost = (redirectUri) => {
	try {
		return new URL(redirectUri).host || '';
	} catch {
		return '';
	}
};
